export default function WaveBackground({ variant = "default" }) {
  return (
    <div className="wave-bg" aria-hidden="true">
      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 1440 800"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="fenco-wave" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E2E8F0" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#F1F5F9" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <path
          d="M0,260 C320,360 540,160 760,220 C980,280 1180,420 1440,300 L1440,0 L0,0 Z"
          fill="url(#fenco-wave)"
        />
        <path
          d="M0,520 C260,620 520,420 800,500 C1060,580 1240,460 1440,540 L1440,800 L0,800 Z"
          fill="url(#fenco-wave)"
          opacity="0.6"
        />
        {variant === "accent" && (
          <circle cx="1280" cy="160" r="280" fill="#FF5A1F" opacity="0.04" />
        )}
      </svg>
    </div>
  );
}
